import { addLinkEventUTMSource, formatBannerEventDate } from "src/functions/dateFormats"
import "./styles.less"

export const EventBanner = ({ link, logo, date }: { link: string, logo: string, date: string }) => {
    return (
        <div className="container-banner-event">
            <a href={addLinkEventUTMSource(link)} className="banner-event" id="banner-event" target="_blank">
                <div className="logo-container">
                    <span>Este proyecto lo podés conocer en</span>
                    <img id="img-event" src={logo} className="logo" />
                </div>

                <div className="right-side">
                    <div className="date">
                        <img src="https://cdn1.infocasas.com.uy/web/655cdc70860e7_preheader-calendario.png" />
                        <span className="banner-date" id="banner-date">
                            {formatBannerEventDate(date)}
                        </span>
                    </div>
                    <img src="https://cdn1.infocasas.com.uy/web/655cdc6c69e65_preheader-cta.png" className="cta" />
                </div>
            </a>
        </div>
    )
}